import { post, get } from "../fetch.v2"
import { getDomainId, getEventId } from "../../utils/store"

class UserPhotoApi {
  url: string

  constructor() {
    const domainId = getDomainId()
    const eventId = getEventId()
    this.url = `/domains/${domainId}/events/${eventId}/users/photos`
  }

  async getMe() {
    return get(`${this.url}/me`)
  }

  async createOne() {
    return post(this.url)
  }
}

export default UserPhotoApi
